<template>
  <div class="simple-layout-wrapper">
    <HeaderNav class="header-nav" :isDashboard="false" :searchQuery="searchQuery"
      @update:searchQuery="$emit('update:searchQuery', $event)" />

    <main ref="pageWrapper" class="main-content">
      <slot />
    </main>
    <BottomNav class="bottom-nav" />
    <chatbot />
  </div>
</template>

<script>
import HeaderNav from "@/layouts/includes/frontend/HeaderNav.vue";
import BottomNav from '@/layouts/includes/frontend/BottomNav.vue';
import { gsapAnimations } from "@/services/gsapAnimations";
import Chatbot from '@/components/templates/Chatbot.vue';

export default {
  props: {
    searchQuery: {
      type: String,
      default: '',
    },
  },
  components: {
    HeaderNav,
    BottomNav,
    Chatbot,
  },

  watch: {
    $route() {
      this.animatePageChange();
    },
  },

  mounted() {
    this.animatePageChange(); // initial load animation
  },

  methods: {
    animatePageChange() {
      gsapAnimations.animatePageChange(this.$refs.pageWrapper);
    }
  },
};
</script>


<style scoped>


.gsap-fade-slide-enter-active,
.gsap-fade-slide-leave-active {
  transition: none;
}

.gsap-fade-slide-enter,
.gsap-fade-slide-leave-to {
  opacity: 0;
}

@media (min-width: 767px) {
  .main-content {
    padding-top: 75px !important;
  }
}

@media (max-width: 767px) {
  .main-content {
    padding-top: 120px !important;
  }
}
</style>
